const createUrlWithSourceQueryParams = ({ url, source, sourceDetail })=>{
    if (!url) {
        console.error('createUrlWithSourceQueryParams: You are providing an empty url!');
        return '';
    }
    const splittedUrl = url.split(/\?(.+)/);
    const urlRoot = splittedUrl[0];
    const urlQueryParams = splittedUrl[1];
    return `${urlRoot}?${urlQueryParams ? `${urlQueryParams}&` : ''}source_page=${source}${sourceDetail ? `&source_detail=${sourceDetail}` : ''}`;
};
const src_createUrlWithSourceQueryParams = createUrlWithSourceQueryParams;
export default src_createUrlWithSourceQueryParams;
